module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/phone-b3fb400b44bfb848b004de1faedb67d4.svg";